<template>
  <div>
    <el-main style="margin: 0 auto;width: 900px;background: none;">
      <div id="echartsContainer" style="min-height: 280px">
      </div>
      <div style="margin-bottom: 8px">
        <el-button size="small" type="primary" @click="getTradeUpHistory">查询</el-button>
        <div v-if="!staticLoading" style="display: inline-block">
          <el-button size="small"  @click="getTradeUpStatistics(Math.floor(new Date().getTime() / 1000))">统计近期数据</el-button>
          <el-button style="cursor:pointer;margin-left: 0px" size="small" @click="getPreTradeUpStatistics()">统计{{  formatterLatestDate() }}数据</el-button>
        </div>
        <div @click="cancelStatic" v-else style="display: inline-block;cursor: pointer">
          <el-button type="danger" :loading="true" size="small">取消统计</el-button>
        </div>
      </div>
      <el-skeleton :loading="loading" animated :count="3">
        <template slot="template">
          <div style="display: flex;margin-bottom: 12px">
            <el-skeleton-item variant="image" style="width: 25%; height: 205px;"/>
            <div style="padding: 14px;width: 75%">
              <el-skeleton-item variant="h3" style="width: 50%;"/>
              <div
                style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;">
                <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                <el-skeleton-item variant="text" style="width: 30%;"/>
              </div>
              <div
                style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;">
                <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                <el-skeleton-item variant="text" style="width: 30%;"/>
              </div>
              <div
                style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;">
                <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                <el-skeleton-item variant="text" style="width: 30%;"/>
              </div>
              <div
                style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;">
                <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                <el-skeleton-item variant="text" style="width: 30%;"/>
              </div>
              <div
                style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;">
                <el-skeleton-item variant="text" style="margin-right: 16px;"/>
                <el-skeleton-item variant="text" style="width: 30%;"/>
              </div>
            </div>
          </div>
        </template>
        <template>
          <div v-if="tradeUpHistory.length != 0" class="infinite-list"
               style="overflow:auto;height: 700px;list-style-type: none;overflow: auto">
            <el-card shadow="never" v-for="(i,index) in tradeUpHistory" :key="index" style="margin: 2px;"
                     :body-style="{'padding':'12px 20px','position':'relative'}">
              <div style="font-size: 13px;justify-content: space-between;display: flex;align-items: center">
                <el-tag :type="i.income - i.cost >= 0 ? 'success':'danger'" size="small" effect="plain">
                  {{ i.income - i.cost >= 0 ? '+' : '-' }}￥{{ Math.abs((i.income - i.cost).toFixed(2)) }}
                </el-tag>
                <el-tag type="warning" effect="plain" size="small">
                  {{ i.createTime == null ? '' : i.createTime.replace('T', ' ') }}
                </el-tag>
              </div>

              <div style="display: flex;align-items: center">
                <div style="width: 24%;margin-right: 1%;text-align: center">
                  <div style="width: 150px;height:125px;margin: 0 auto;position: relative">
                    <img style="height: 90px" :src="i.iconUrl" :alt="i.engName"/>
                    <div style="position: absolute;bottom: 35px;">
                      <el-tag size="small" type="info" :style="formatterWear(i)" style="opacity: 0.9">
                        {{ $t(regexWear(i.engName)) }}
                      </el-tag>
                    </div>
                    <div class="item-details-row-light" style="height: 20px;margin-bottom: 8px;">
                  <span class="item-details-row__label">
                    <el-tag type="info" size="small">￥{{
                        i.income == null ? '' : i.income.toFixed(2)
                      }}
                    </el-tag>
                  </span>
                      <span class="item-details-row__value">
                     <el-tag v-if="i.rarityName" size="small" type="info" style="float: right;max-width: 85px;"
                             :style="formatterRarity(i.rarityName)">
                      {{ formatterLocalRarityName(i) }}
                    </el-tag>
                  </span>
                    </div>
                  </div>
                  <div style="font-size: 13px">
                    {{ formatterLocalName(i) }}
                  </div>
                </div>
                <div style="width: 75%;flex: 1">
                  <div>
                    <div v-for="item of i.craftItems"
                         style="display: inline-block;text-align: center;margin-bottom: 1%;width: 20%">
                      <div style="position: relative">
                        <img style="width: 75px" :src="item.iconUrl" :alt="item.engName"/>
                        <div class="item-details-row-light" style="height: 20px;margin-bottom: 4px;">
                      <span class="item-details-row__label">
                        <el-tag type="info" size="small">￥{{
                            item.price == null ? '' : item.price.toFixed(2)
                          }}
                        </el-tag>
                      </span>
                          <span class="item-details-row__value">
                      </span>
                        </div>
                        <div style="font-size: 12px;white-space: nowrap">
                          {{ item.weaponCase }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
          <div v-else style="text-align: center;color: #aaaaaa">
            <h3>暂无数据,请先进行统计</h3>
          </div>
        </template>
      </el-skeleton>
    </el-main>
  </div>
</template>

<script>
import {tradeUpHistory} from "../../api/api";
import {formatterWear, regexWear} from "../../api/util";
import * as echarts from "echarts";

const {delay} = require("../../api/util");
const {formatterTime} = require("../../api/util");
const {tradeUpStatistics} = require("../../api/api");

export default {
  name: "tradeUpHistory",
  data() {
    return {
      limit: 10,
      offset: 1,
      tradeUpHistory: [],
      loading: false,
      staticLoading: false,
      echarts:{},
      echartsOption: {
        title: {
          text: '炼金记录'
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            name: 'Income',
            data: [],
            type: 'line',
            smooth: true
          }
        ]
      },
    }
  },
  methods: {
    regexWear(engName) {
      return regexWear(engName)
    },
    formatterWear(inventoryItem) {
      let wearArr = inventoryItem.engName.match(/\(([^)]*)\)/)
      if (wearArr != null && wearArr !== undefined && wearArr.length > 1) {
        return formatterWear(wearArr[1])
      } else {
        return ''
      }
    },
    formatterLocalRarityName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.rarityName
      } else {
        return item.rarity
      }
    },
    formatterLocalName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'en') {
        return item.engName
      } else {
        return item.cnName
      }
    },
    formatterRarity(val) {
      switch (val) {
        case '消费级':
          return 'color: #b0c3d9;'
        case '军规级':
          return 'color: #4b69ff;'
        case '受限':
          return 'color: #8847ff;'
        case '保密':
          return 'color: #d32ce6;'
        case '隐秘':
          return 'color: #eb4b4b;'
        case '违禁':
          return 'color: #e4ae39;'
        case '非凡':
          return 'color: #eb4b4b;'
        case '卓越':
          return 'color: #8847ff;'
        case '奇异':
          return 'color: #d32ce6;'
        case '高级':
          return 'color: #4b69ff;'
        case '普通级':
          return 'color: #b0c3d9;'
        case '不朽':
          return 'color: #F2B166;'
        case '至宝':
          return 'color: #9ACC4C;'
        case '神话':
          return 'color: #A876F9;'
        case '珍稀':
          return 'color: #7C8FF5;'
        case '罕见':
          return 'color: #82BDFF;'
        default:
          return ''
      }
    },
    getTradeUpStatistics(timestamp) {
      this.staticLoading = true
      tradeUpStatistics({timeStamp: timestamp}).then(async json => {
        if (json.data.flag === 'T') {
          this.$message({
            message: '统计成功,已统计至' + formatterTime(json.data.data) + " 10秒后继续统计",
            type: 'success'
          });
          await delay(5 * 1000); // 延迟10秒钟
          if (this.staticLoading){
            this.getTradeUpStatistics(Math.floor(json.data.data / 1000))
          }
        } else {
          this.staticLoading = false
        }
      })
    },
    getPreTradeUpStatistics() {
      // 从data中取最后一条数据
      let timestamp = Math.floor(new Date().getTime() / 1000)
      if (this.tradeUpHistory.length != 0) {
        timestamp = Math.floor(new Date(this.tradeUpHistory[this.tradeUpHistory.length - 1].createTime).getTime() / 1000)
      }
      this.getTradeUpStatistics(timestamp)
    },
    formatterLatestDate(){
      if (this.tradeUpHistory.length == 0){
        return '历史'
      }else{
        return this.tradeUpHistory[this.tradeUpHistory.length - 1].createTime.split('T')[0] + '之前'
      }
    },
    getTradeUpHistory() {
      this.loading = true
      this.echarts.showLoading()
      tradeUpHistory({limit: this.limit, offset: this.offset}).then(json => {
        this.tradeUpHistory = json.data.data.rows

        this.$set(this.echartsOption.xAxis,'data',json.data.data.timeLine)
        this.$set(this.echartsOption.series[0],'data',json.data.data.incomeLine)
        this.echarts.setOption(this.echartsOption);
      }).finally(_ => {
        this.loading = false
        this.echarts.hideLoading()
      })
    },
    cancelStatic(){
      this.staticLoading = false
    }
  },
  mounted() {
    this.echarts = echarts.init(document.getElementById('echartsContainer'), {locale: 'ZH'})
    this.getTradeUpHistory()
  }
}
</script>

<style scoped>
.item-details-row-light {
  display: flex;
  height: 15px;
  text-align: left;
  font-size: 12px;
  align-items: center;
  margin-bottom: 2px;
}

.item-details-row__value {
  flex: 1;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/ui/TradeupHistory/index.vue